import styled from "styled-components";
import { colors, darkModeColors } from "../../consts";

export const TextWrapper = styled.p`
  font-weight: inherit;
  font-size: inherit;
  line-height: inherit;
  color: ${(props) => props?.style?.color ?? "inherit"};

  white-space: ${(props) => (props?.lines > 1 ? "wrap" : "pre")};
  overflow: hidden;
  text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;

  max-width: ${(props) => (props?.maxWidth ? props.maxWidth : "inherit")};

  display: ${(props) => (props?.lines && props?.lines > 1 ? "-webkit-box" : "block")};

  ${(props) => props?.lines && props?.lines > 1 && `-webkit-line-clamp: ${props.lines}`};
  ${(props) => props?.lines && props?.lines > 1 && `line-clamp: ${props.lines}`};
  ${(props) => props?.lines && props?.lines > 1 && `-webkit-box-orient: vertical`};

  b {
    background: ${colors.TURQUOISE_100};
  }

  &:focus:after,
  &:hover:after {
    content: attr(data-text);
    overflow: visible;
    text-overflow: inherit;
    white-space: normal;
    word-wrap: break-word;
    display: ${(props) => (props?.overflowActive ? "block" : "none")};

    ${(props) => props?.lines && props?.lines > 1 && `min-height: ${26 * props.lines}px`};

    position: absolute;
    z-index: 100;
    left: auto;
    top: auto;
    max-width: ${(props) =>
      props?.lines && props?.lines > 1 && props?.maxWidth
        ? `${props.maxWidth * props.lines}px`
        : "inherit"};

    margin-top: ${(props) =>
      props?.lines && props?.lines > 1 && props?.scrollHeight
        ? `-${props.scrollHeight}px`
        : "-26px"};
    margin-left: -8px;
    padding: 0 8px;
    border-radius: 4px;
    border: ${(props) => props?.theme?.darkMode && `1px solid rgba(110, 110, 116, 0.55)`};

    background: ${darkModeColors.WHITE_RAISIN_100};
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.16);
    color: ${colors.RAISIN_100};
  }
`;
